import { Injectable } from '@angular/core';
import { ROUTES } from '../../server-route';
import {
  PrintAndMonitorMemberData,
  PrintAndMonitorResponseData,
} from '../interfaces/print-and-monitor';
import { Observable } from 'rxjs';
import { ApiService } from '../../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class PrintAndMonitorService extends ApiService {
  public fetchReports(paramsObj: any): Observable<PrintAndMonitorResponseData> {
    return this.get<PrintAndMonitorResponseData>(
      ROUTES.PRINT_AND_MONITOR_FULL_DATA,
      {
        params: paramsObj,
      }
    );
  }

  public fetchReportsAllCountry(
    paramsObj: any
  ): Observable<PrintAndMonitorResponseData> {
    return this.get<PrintAndMonitorResponseData>(
      ROUTES.PRINT_AND_MONITOR_FULL_DATA_ALL_COUNTRY,
      {
        params: paramsObj,
      }
    );
  }
  public fetchReportsAllCountryForReports(
    paramsObj: any
  ): Observable<PrintAndMonitorResponseData> {
    return this.get<PrintAndMonitorResponseData>(
      ROUTES.REPORTS_FULL_DATA_ALL_COUNTRY,
      {
        params: paramsObj,
      }
    );
  }

  public fetchReportsForMembers(
    paramsObj: any
  ): Observable<PrintAndMonitorMemberData> {
    return this.get<PrintAndMonitorMemberData>(
      ROUTES.PRINT_AND_MONITOR_MEMBERS,
      {
        params: paramsObj,
      }
    );
  }

  public fetchReportsStagnantData(
    paramsObj: any
  ): Observable<PrintAndMonitorMemberData> {
    return this.get<PrintAndMonitorMemberData>(
      ROUTES.STAGNANT_MEMBERS,
      {
        params: paramsObj,
      }
    );
  }

  public fetchDatumUsers(
    paramsObj: any
  ): Observable<PrintAndMonitorResponseData> {
    return this.get<PrintAndMonitorResponseData>(ROUTES.WISHLIST_USERS, {
      params: paramsObj,
    });
  }
  public checkStagnantStatus(paramasObj: any): Observable<any> {
    return this.get<any>(ROUTES.STAGNANT_STATUS, {
      params: paramasObj,
    });
  }
  public addToFavorites(bodyObj: any): Observable<any> {
    return this.post<any>(ROUTES.PRINT_AND_MONITOR_ADD_FAV, {
      body: bodyObj,
    });
  }
  public deleteItemFavorites(member: any): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.PRINT_AND_MONITOR_DEL_FAV, {
        member,
      })
    );
  }
  public getFavorites(paramsObj: any): Observable<any> {
    return this.get<any>(ROUTES.PRINT_AND_MONITOR_ADD_FAV, {
      params: paramsObj,
    });
  }
  public editStagDetails(bodyObj: any): Observable<any> {
    return this.patch<any>(ROUTES.STAGNANT_EDIT, {
      body: bodyObj,
    });
  }
  public addStagDetails(bodyObj: any): Observable<any> {
    return this.post<any>(ROUTES.STAGNANT_EDIT, {
      body: bodyObj,
    });
  }
  public getNoteDetails(memKey: any): Observable<any> {
    return this.get<any>(ROUTES.STAGNANT_EDIT, {
      params: { memkey: memKey },
    });
  }
}
